import axios from 'axios'

const PRODUCTS_FETCHED = 'PRODUCTS_FETCHED'
const CHANNELS_FETCHED = 'CHANNELS_FETCHED'
const UPDATE_FORM = 'UPDATE_FORM'
const RESET_FORM = 'RESET_FORM'
const CODES_CREATED = 'CODES_CREATED'

const API_URL = process.env.API_URL

const form = {
  id: '',
  channel: '',
  expire: null,
  amount: 1
}

const state = {
  products: [],
  channels: [],
  form: {...form},
  codes: []
}

const getters = {
  productsAsOptions: state => {
    return state.products.reduce((m, {name: label, store_id: value}) => {
      m[label.startsWith('maps.') ? 1 : 0].options.push({value, label})
      return m
    }, [
      {label: 'General', options: []},
      {label: 'Maps', options: []}
    ])
  },
  codesAsString: state => separator => state.codes.join(separator || ', '),
  channels: state => state.channels
}

const actions = {
  fetchProducts: ({commit}) => {
    return axios.get(API_URL + '/products').then(response => {
      const products = response.data.data
      commit(PRODUCTS_FETCHED, products)
    })
  },
  fetchChannels: async ({commit}) => {
    const response = await axios.get(`${API_URL}/voucher/channels`)
    commit(CHANNELS_FETCHED, response.data.data)
  },
  createChannel: async ({ commit, dispatch, state }, data) => {
    await axios.post(`${API_URL}/voucher/channels`, data)
    await dispatch('fetchChannels')
  },
  updateForm: ({commit}, data) => {
    commit(UPDATE_FORM, data)
  },
  resetForm: ({commit}, data) => {
    commit(RESET_FORM)
  },
  createVouchers: ({commit, state: {form}}) => {
    return axios.post(API_URL + '/voucher', {
      ...form,
      expire: form.expire.getTime()
    }).then(({data: {code}}) => {
      commit(CODES_CREATED, code)
      return code
    })
  },
  redeemVoucher: async (store, data) => {
    const response = await axios.post(`${API_URL}/voucher/redeem`, data)
    if (response.status === 250) {
      throw new Error(response.data.data)
    }
  }
}

const mutations = {
  [PRODUCTS_FETCHED] (state, products) {
    state.products = products
  },
  [CHANNELS_FETCHED] (state, channels) {
    state.channels = channels
  },
  [UPDATE_FORM] (state, data) {
    Object.keys(form).forEach(prop => {
      const value = data[prop]
      if (value !== void 0) {
        state.form[prop] = value
      }
    })
  },
  [RESET_FORM] (state) {
    state.form = {...form}
    state.codes = []
  },
  [CODES_CREATED] (state, codes) {
    state.codes = codes
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vouchers.js